import { useCallback, useEffect, useRef } from 'react';
import DatePicker from 'react-multi-date-picker';
import { trapActiveDatePickerOverlayFocus } from './datePickerFocusTrap';

const FocusTrappedDatePicker = ({ onOpen, onClose, ...props }) => {
  const datePickerRef = useRef(null);
  const focusTrapCleanupRef = useRef(null);

  const clearFocusTrap = useCallback(() => {
    if (focusTrapCleanupRef.current) {
      focusTrapCleanupRef.current();
      focusTrapCleanupRef.current = null;
    }
  }, []);

  useEffect(() => (
    () => {
      clearFocusTrap();
    }
  ), [clearFocusTrap]);

  const handleOpen = () => {
    clearFocusTrap();
    focusTrapCleanupRef.current = trapActiveDatePickerOverlayFocus({
      onEscape: () => {
        if (datePickerRef.current && typeof datePickerRef.current.closeCalendar === 'function') {
          datePickerRef.current.closeCalendar();
        }
      },
    });
    if (onOpen) {
      onOpen();
    }
  };

  const handleClose = () => {
    clearFocusTrap();
    if (onClose) {
      onClose();
    }
  };

  return (
    <DatePicker
      {...props}
      ref={datePickerRef}
      onOpen={handleOpen}
      onClose={handleClose}
    />
  );
};

export default FocusTrappedDatePicker;
